<template>
  <validation-observer
    ref="saveFormRef"
    #default="{invalid}"
  >
    <b-form>
      <b-row>
        <!-- Name Semester -->
        <b-col cols="12">
          <b-form-group label-for="name-semester">
            <template v-slot:label>
              Tên học kỳ <span class="text-danger">*</span>
            </template>
            <validation-provider
              #default="{ errors }"
              name="Tên học kỳ"
              rules="required"
            >
              <b-form-input
                id="name-semester"
                v-model="dataSemester.name"
                name="nameSemester"
                placeholder="Tên học kỳ"
                :state="getElementState(errors)"
              />
              <small class="text-danger">{{ errors[0] }}</small>
            </validation-provider>
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <b-form-group
            label="Loại học kỳ"
            label-for="semesterTypes"
          >
            <b-form-select
              id="status"
              v-model="dataSemester.semesterTypeId"
              :options="optSemesterTypes"
            />
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group
            label="Trạng thái"
            label-for="status"
          >
            <b-form-select
              id="status"
              v-model="dataSemester.status"
              :options="optionsStatus"
            />
          </b-form-group>
        </b-col>
        <b-col cols="6">
          <b-form-group
            label="Số thứ tự"
            label-for="status"
          >
            <b-form-input
              id="order_no"
              v-model="dataSemester.orderNo"
              type="number"
            />
          </b-form-group>
        </b-col>
        <b-col cols="12">
          <div class="float-left">
            <b-button
              type="submit"
              variant="primary"
              class="mr-1"
              :disabled="invalid"
              @click="handleSaveData"
            >
              Lưu
            </b-button>
          </div>

        </b-col>
      </b-row>
    </b-form>
  </validation-observer>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import {
  BButton, BCol, BForm, BFormGroup, BFormInput, BFormInvalidFeedback, BFormSelect, BRow,
} from 'bootstrap-vue'
import { ValidationObserver, ValidationProvider } from 'vee-validate'

export default {
  name: 'FormSemester',
  components: {
    ValidationObserver,
    ValidationProvider,
    BForm,
    BFormInvalidFeedback,
    BButton,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BFormSelect,
  },
  props: {
    dataSemester: {
      type: Object,
      default: () => {},
    },
  },

  data() {
    return {
      formErr: {
        nameSemester: '',
        maHocKy: '',
      },
      optionsStatus: [],
      optSemesterTypes: [],
    }
  },

  async created() {
    // init data FROM API
    await this.getInit()
    this.optSemesterTypes = this.semesterTypes.map(item => ({ value: item.id, text: item.name }))
    if (!this.dataSemester.semesterTypeId) {
      this.dataSemester.semesterTypeId = this.optSemesterTypes[0].value
    }
    this.optionsStatus = this.statuses.map(item => ({ value: item.id, text: item.name }))
    if (!this.dataSemester.status) {
      this.dataSemester.status = 1
    }
  },

  computed: {
    // calculate data from init data
    ...mapGetters({
      semesterTypes: 'semester/semesterTypes',
      statuses: 'semester/statuses',
    }),
  },
  methods: {
    ...mapActions({
      getInit: 'semester/getInit',
    }),
    // handle even
    handleSaveData(e) {
      const data = this.dataSemester
      this.$emit('saveDataSemester', data)
      e.preventDefault()
    },
    resetForm() {
      this.$nextTick(() => {
        this.$refs.observer.reset()
      })
    },
    getElementState(errors) {
      return errors.length > 0 ? false : null
    },
  },
}
</script>

<style scoped>

</style>
